import { mapSDUITextToSlateTypographyPropsArray } from "@faire/deprecated-retailer-visitor-shared/components/SDUI/PropsAdapters/SDUITextPropsAdapter";
import { ISDUIText } from "@faire/web-api--source/indigofair/data/ISDUIText";
import { Typography } from "@faire/web/slate/Typography";

export const SDUITextRenderer = ({ text }: { text: ISDUIText | undefined }) => {
  if (!text) {
    return null;
  }

  const textPropsArray = mapSDUITextToSlateTypographyPropsArray(text);

  return textPropsArray.map((textProps, i) => {
    return <Typography key={`SDUITextRenderer-${i}`} {...textProps} />;
  });
};
